
import * as React from 'react';
import { RadialPieChart } from './RadialPieChart';
import { colors } from '../colors/color';

type RadialChartProps = {
    value:string,
    fillPct:number,
    color?:string,
    dim?:string,
    fontSize?:string,
    maxWidth?:string
}
export function RadialChart(props:RadialChartProps):JSX.Element
{

    const color = props.color || colors.radialChart.blue;

    return (
        <RadialPieChart
            value={props.value}
            segments={[
                {value:props.fillPct, color}, 
                {value:100 - props.fillPct, color:colors.radialChart.unfilled}
            ]}
            dim={props.dim}
            fontSize={props.fontSize}
            maxWidth={props.maxWidth}
        />
    );
}